module.exports = __webpack_public_path__ + "static/media/Location.bc39aba0.svg";